import WsFilterProps from '../models/WsFilterProps';

import CheckboxListFilter from './CheckboxListFilter';

export const aiContactPreferrence = {
  Phone: 'Phone',
  Email: 'Email',
};

const AiContactAvailabilityFilter = ({ name }: WsFilterProps) => (
  <CheckboxListFilter
    name={name}
    options={aiContactPreferrence}
    title="Contact Availability"
    defaultExpanded={true}
  />
);

export default AiContactAvailabilityFilter;
